import {
  IonBackButton,
  IonButtons,
  IonHeader,
  IonPage,
  IonToolbar,
} from "@ionic/react"

import { useParams } from "react-router"
import { DrawingId } from "../entities"

import { Title } from "../components/Title"
import { Session } from "../Session"
import { useQuery } from "convex/react"
import { api } from "../convex/_generated/api"
import { JsonViewer } from "@textea/json-viewer"

export function DrawingPageDebug() {
  const { drawingId } = useParams() as { drawingId: DrawingId }

  const drawing = useQuery(api.drawings.getDrawing, {
    drawingId: drawingId,
  })
  const drawingData =
    useQuery(api.drawings.getDrawingData, { drawingId }) ?? null

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/"></IonBackButton>
          </IonButtons>

          <Title>Debug</Title>

          <IonButtons slot="end">
            <Session />
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <div style={{ height: "100%", overflow: "auto", fontSize: 11 }}>
        <h2>Drawing</h2>
        {drawing && <JsonViewer value={drawing} defaultInspectDepth={2} />}
        <h2>Drawing Store</h2>
        {drawingData && (
          <JsonViewer value={drawingData} defaultInspectDepth={2} />
        )}
      </div>
      {/* <pre style={{ fontFamily: "monospace", fontSize: 10 }}>
        {JSON.stringify(drawing, null, 2)}
        <br />
        {JSON.stringify(drawingData, null, 2)}
      </pre> */}
    </IonPage>
  )
}
